/**
 * Normalize list responses from the Flask compatibility routes.
 *
 * Some legacy endpoints return a bare JSON array while paged endpoints
 * return a paginator object with a `data` array.  Reducers and views can
 * consume the same one-page shape for either response.
 */
export const normalizeListResponse = (response) => {
  if (response && !Array.isArray(response) && Array.isArray(response.data)) {
    return response;
  }

  const rows = Array.isArray(response) ? response : [];
  return {
    current_page: 1,
    data: rows,
    last_page: 1,
    next_page_url: null,
    per_page: rows.length,
    prev_page_url: null,
    total: rows.length,
  };
};
